import { List, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { SyncthingFolder } from 'src/api/types';

type Props = {
  syncthingFolder: SyncthingFolder | null;
  title?: string;
};

export const SyncthingFolderDetails: FC<Props> = memo(
  ({ syncthingFolder, title = 'Syncthing Folder Details' }) => {
    if (!syncthingFolder) {
      return null;
    }

    return (
      <>
        <Text fw={500} size="lg">
          {title}
        </Text>

        <List spacing="xs" listStyleType="none">
          <List.Item>
            <Text size="xs">
              Folder ID:{' '}
              <Text component="span" fw={600} c="var(--color-white)">
                {syncthingFolder.folder_id}
              </Text>
            </Text>
          </List.Item>
          <List.Item>
            <Text size="xs">
              Label:{' '}
              <Text component="span" fw={600} c="var(--color-white)">
                {syncthingFolder.label}
              </Text>
            </Text>
          </List.Item>
          <List.Item>
            <Text size="xs">
              Path:{' '}
              <Text component="span" fw={600} c="var(--color-white)">
                {syncthingFolder.path}
              </Text>
            </Text>
          </List.Item>
          <List.Item>
            <Text size="xs">
              Type:{' '}
              <Text component="span" fw={600} c="var(--color-white)">
                {syncthingFolder.type}
              </Text>
            </Text>
          </List.Item>
          <List.Item>
            <Text size="xs">
              Sync Type:{' '}
              <Text component="span" fw={600} c="var(--color-white)">
                {syncthingFolder.sync_type}
              </Text>
            </Text>
          </List.Item>
        </List>
      </>
    );
  }
);

SyncthingFolderDetails.displayName = 'SyncthingFolderDetails';
